<template>
  <div class="markdown-view-box">
    <link rel="stylesheet" href="./editor.md/css/editormd.min.css" />
    <link rel="stylesheet" href="./css/tw-markdown-view.css" />
    <link rel="stylesheet" href="./editor.md/css/editormd.preview.min.css" />
    <div id="markdown-view">
      <textarea style="display: none;">{{doc.content}}</textarea>
    </div>
  </div>
</template>
<script>
import scriptjs from 'scriptjs'
import utils from '@/config/cookieUtils'
import { defaultConfig } from '../../config/editor.md'
export default {
  props: {
    viewId: {
      type: String,
      default: 'markdown-view'
    },
    config: {
      // 编辑器配置
      type: Object
    },
    initData: {
      type: String
    },
    initDataDelay: {
      type: Number, // 延迟初始化数据时间，单位毫秒
      default: 0
    }
  },
  data: function () {
    return {
      doc: {},
      editor: null
    }
  },
  methods: {
    fetchScript: function (url) {
      return new Promise((resolve) => {
        scriptjs(url, () => {
          resolve()
        })
      })
    },
    getDoc: function () {
      return this.doc
    },
    getConfig: function () {
      return { ...defaultConfig, ...this.config }
    },
    forceUpdate: function () {
      this.$forceUpdate()
    },
    initView: function () {
      ;(async () => {
        await this.fetchScript('./editor.md/jquery.min.js')
        await this.fetchScript('./editor.md/jquery-migrate-3.4.0.js')
        await this.fetchScript('./editor.md/lib/marked.min.js')
        await this.fetchScript('./editor.md/lib/prettify.min.js')
        await this.fetchScript('./editor.md/lib/raphael.min.js')
        await this.fetchScript('./editor.md/lib/underscore.min.js')
        await this.fetchScript('./editor.md/lib/sequence-diagram.min.js')
        await this.fetchScript('./editor.md/lib/flowchart.min.js')
        await this.fetchScript('./editor.md/lib/jquery.flowchart.min.js')
        await this.fetchScript('./editor.md/editormd.min.js')
        // console.log(this.viewId, this.getConfig(), 'this.viewId')
        this.$nextTick(() => {
          this.editor = window.editormd.markdownToHTML(
            this.viewId,
            this.getConfig()
          )
        })
      })()
    },
    setDoc (doc) {
      if (doc) {
        let vm = this
        vm.doc = doc
        let markdownViewDiv = document.getElementById('markdown-view')
        if (markdownViewDiv) {
          markdownViewDiv.innerHTML =
            '<textarea style="display: none;"></textarea>'
          vm.initView()
          if (doc.content) {
            markdownViewDiv.getElementsByTagName('textarea')[0].innerHTML =
              doc.content
          }
        }
      }
    },
    showContent (id) {
      let vm = this
      if (id === '' || id === undefined || id.length === 0) {
        return
      }
      vm.$store.state.editor.isEditing = false
      vm.axios
        .get('/openapi-uc/doc/getDocById/' + id)
        .then(function (response) {
          if (
            response.data &&
            response.data.pageInfo &&
            response.data.pageInfo.list &&
            response.data.pageInfo.list.length > 0
          ) {
            vm.$store.commit('hasDoc', true)
            let doc = response.data.pageInfo.list[0]
            if (doc) {
              vm.doc = doc
              let markdownViewDiv = document.getElementById('markdown-view')
              if (markdownViewDiv) {
                markdownViewDiv.innerHTML =
                  '<textarea style="display: none;"></textarea>'
                vm.initView()
                if (doc.content) {
                  markdownViewDiv.getElementsByTagName(
                    'textarea'
                  )[0].innerHTML = doc.content
                }
              }
            } else {
              vm.$store.commit('hasDoc', false)
            }
          }
        })
    }
  },
  mounted: function () {
    let vm = this
    let docId = ''
    docId =
      vm.$store.state.MenuId === ''
        ? utils.get('nowMenuId')
        : vm.$store.state.MenuId
    vm.showContent(docId)
  }
}
</script>



// WEBPACK FOOTER //
// tw-markdown-view.vue?7a895e5f